import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { CONVERSATION_PERMISSIONS } from 'dashboard/constants/permissions.js';
import {
  getUserPermissions,
  hasPermissions,
} from 'dashboard/helper/permissionsHelper';
import store from '../../../../store';

import ReportsWrapper from './components/ReportsWrapper.vue';

import AgentReportsIndex from './AgentReportsIndex.vue';
import InboxReportsIndex from './InboxReportsIndex.vue';
import TeamReportsIndex from './TeamReportsIndex.vue';
import LabelReportsIndex from './LabelReportsIndex.vue';

import AgentReportsShow from './AgentReportsShow.vue';
import InboxReportsShow from './InboxReportsShow.vue';
import TeamReportsShow from './TeamReportsShow.vue';
import LabelReportsShow from './LabelReportsShow.vue';

import CsatResponses from './CsatResponses.vue';
import BotReports from './BotReports.vue';
import AgentActivityReports from './AgentActivityReports.vue';
import AgentActivityDetail from './AgentActivityDetail.vue';
import LiveReports from './LiveReports.vue';
import OverviewReportsIndex from './OverviewReportsIndex.vue';
import ChatsReportsIndex from './ChatsReportsIndex.vue';
// import SLAReports from './SLAReports.vue';
import QueuedCustomersReports from './QueuedCustomersReports.vue';
import ReportSchedules from './ReportSchedules.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.REPORTS,
  permissions: ['administrator', 'report_manage'],
};

const ownAgentReportMeta = {
  featureFlag: FEATURE_FLAGS.REPORTS,
  permissions: [
    'administrator',
    'agent',
    'report_manage',
    ...CONVERSATION_PERMISSIONS,
  ],
};

const canViewAllReports = accountId => {
  const permissions = getUserPermissions(
    store.getters.getCurrentUser,
    accountId
  );
  return hasPermissions(['administrator', 'report_manage'], permissions);
};

const redirectToOwnAgentReport = to => ({
  name: 'agent_reports_show',
  params: { ...to.params, id: store.getters.getCurrentUserID },
  query: to.query,
});

const legacyReportRedirects = [
  {
    path: 'agent',
    name: 'agent_reports',
    redirect: { name: 'agent_reports_index' },
  },
  {
    path: 'inboxes',
    name: 'inbox_reports',
    redirect: { name: 'inbox_reports_index' },
  },
  {
    path: 'label',
    name: 'label_reports',
    redirect: { name: 'label_reports_index' },
  },
  {
    path: 'teams',
    name: 'team_reports',
    redirect: { name: 'team_reports_index' },
  },
];

const revisedReportRoutes = [
  {
    path: 'agents_overview',
    name: 'agent_reports_index',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: AgentReportsIndex,
  },
  {
    path: 'agents/:id',
    name: 'agent_reports_show',
    meta: ownAgentReportMeta,
    beforeEnter: (to, _from, next) => {
      if (canViewAllReports(to.params.accountId)) {
        next();
        return;
      }
      if (Number(to.params.id) === Number(store.getters.getCurrentUserID)) {
        next();
        return;
      }
      next(redirectToOwnAgentReport(to));
    },
    component: AgentReportsShow,
  },

  {
    path: 'inboxes_overview',
    name: 'inbox_reports_index',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: InboxReportsIndex,
  },
  {
    path: 'inboxes/:id',
    name: 'inbox_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: InboxReportsShow,
  },
  {
    path: 'teams_overview',
    name: 'team_reports_index',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: TeamReportsIndex,
  },
  {
    path: 'teams/:id',
    name: 'team_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: TeamReportsShow,
  },
  {
    path: 'labels_overview',
    name: 'label_reports_index',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: LabelReportsIndex,
  },
  {
    path: 'labels/:id',
    name: 'label_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: LabelReportsShow,
  },
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: ReportsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            if (canViewAllReports(to.params.accountId)) {
              return { name: 'account_overview_reports', params: to.params };
            }
            return redirectToOwnAgentReport(to);
          },
        },
        {
          path: 'overview',
          name: 'account_overview_reports',
          meta,
          component: OverviewReportsIndex,
        },
        {
          path: 'live',
          name: 'account_live_reports',
          meta,
          component: LiveReports,
        },
        {
          path: 'conversation',
          name: 'conversation_reports',
          meta,
          component: ChatsReportsIndex,
        },
        ...legacyReportRedirects,
        ...revisedReportRoutes,
        // {
        //   path: 'sla',
        //   name: 'sla_reports',
        //   meta,
        //   component: SLAReports,
        // },
        {
          path: 'csat',
          name: 'csat_reports',
          meta,
          component: CsatResponses,
        },
        {
          path: 'bot',
          name: 'bot_reports',
          meta,
          component: BotReports,
        },
        {
          path: 'agent_activity',
          name: 'agent_activity_reports',
          meta,
          component: AgentActivityReports,
        },
        {
          path: 'agent_activity/:id',
          name: 'agent_activity_detail',
          meta,
          component: AgentActivityDetail,
        },
        {
          path: 'queued-customers',
          name: 'queued_customers_reports',
          meta,
          component: QueuedCustomersReports,
        },
        {
          path: 'schedules',
          name: 'report_schedules',
          meta,
          component: ReportSchedules,
        },
      ],
    },
  ],
};
